import * as React from 'react';
import { IgcCardHeaderComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A container component for the card's header section.
 * Displays header content including an optional thumbnail, title, subtitle, and additional content.
 * @slot thumbnail - Renders header media such as an icon or small image.
 * @slot title - Renders the card title (typically a heading element).
 * @slot subtitle - Renders the card subtitle (typically a smaller heading or text).
 * @slot  - Renders additional content displayed next to the title area.
 * @csspart header - The card header text container.
 * @csspart title - The title slot wrapper.
 * @csspart subtitle - The subtitle slot wrapper.
 * @class
 */
export const IgrCardHeader = /* @__PURE__ */ createComponent({
  tagName: 'igc-card-header',
  displayName: 'IgrCardHeader',
  elementClass: Component,
  react: React,
});

export type IgrCardHeader = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCardHeaderModule = Component;
